var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2083 8.16663C24.2083 8.64987 23.8166 9.04163 23.3333 9.04163H4.66667C4.18342 9.04163 3.79167 8.64987 3.79167 8.16663C3.79167 7.68338 4.18342 7.29163 4.66667 7.29163H23.3333C23.8166 7.29163 24.2083 7.68338 24.2083 8.16663Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2083 14C24.2083 14.4832 23.8166 14.875 23.3333 14.875H4.66667C4.18342 14.875 3.79167 14.4832 3.79167 14C3.79167 13.5168 4.18342 13.125 4.66667 13.125H23.3333C23.8166 13.125 24.2083 13.5168 24.2083 14Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2083 19.8334C24.2083 20.3166 23.8166 20.7084 23.3333 20.7084H4.66667C4.18342 20.7084 3.79167 20.3166 3.79167 19.8334C3.79167 19.3501 4.18342 18.9584 4.66667 18.9584H23.3333C23.8166 18.9584 24.2083 19.3501 24.2083 19.8334Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.59ac00adb9edad29e77a17440426a032.svg";
export { ForwardRef as ReactComponent };